(function () {
  if (!window.matchMedia('(pointer: fine)').matches) return;

  var IMG_URL = 'https://cdn.shopify.com/s/files/1/0779/1165/4656/files/CrossHair.png?v=1782872965';
  var SIZE = 56;

  var style = document.createElement('style');
  style.textContent =
    '* { cursor: none !important; }' +
    '#eg-cursor {' +
      'position: fixed;' +
      'top: 0; left: 0;' +
      'width: ' + SIZE + 'px;' +
      'height: ' + SIZE + 'px;' +
      'pointer-events: none;' +
      'z-index: 2147483647;' +
      'transform: translate(-200px,-200px);' +
      'will-change: transform;' +
    '}' +
    '#eg-cursor img {' +
      'width: 100%; height: 100%;' +
      'object-fit: contain;' +
      'display: block;' +
    '}';
  document.head.appendChild(style);

  var el = document.createElement('div');
  el.id = 'eg-cursor';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML = '<img src="' + IMG_URL + '" alt="">';

  var cx = -200, cy = -200, rafId = null;

  function render() {
    el.style.transform =
      'translate(calc(' + cx + 'px - 50%), calc(' + cy + 'px - 50%))';
    rafId = null;
  }

  document.addEventListener('mousemove', function (e) {
    cx = e.clientX;
    cy = e.clientY;
    if (!rafId) rafId = requestAnimationFrame(render);
  });

  function attach() {
    if (document.body) document.body.appendChild(el);
  }

  if (document.body) {
    attach();
  } else {
    document.addEventListener('DOMContentLoaded', attach);
  }
}());
